export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Filter.vue?vue&type=template&id=2d1290b9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/Filter.vue?vue&type=template&id=2d1290b9&scoped=true
// module id = 1707
// module chunks = 31